import { z } from 'zod';
export const SCHEDULED_REPORT_TYPES = [
    'compliance',
    'compliance-expired',
    'compliance-expiring',
    'compliance-missing',
    'compliance-suppliers',
    'compliance-docs',
    'compliance-geofence',
    'compliance-dataquality',
    'deployments',
    'projects-keyroles',
    'timesheet',
    'calendar',
    'training-matrix',
    'training-matrix-deployed-by-project',
    'training-matrix-deployed-flat',
    'visa-expiry',
    'deployment-week',
];
export const SCHEDULED_REPORT_TYPE_LABELS = {
    'compliance': 'Monthly Compliance Report',
    'compliance-expired': 'Compliance: Expired Certs',
    'compliance-expiring': 'Compliance: Expiring 30 Days',
    'compliance-missing': 'Compliance: Missing Certs',
    'compliance-suppliers': 'Compliance: Non-Compliant Suppliers',
    'compliance-docs': 'Compliance: Unsigned Docs',
    'compliance-geofence': 'Compliance: Geofence Anomalies',
    'compliance-dataquality': 'Compliance: Data Quality',
    'deployments': 'Active Deployments',
    'projects-keyroles': 'Projects: Key Role Assignments',
    'timesheet': 'Timesheets',
    'calendar': 'Availability Calendar',
    'training-matrix': 'Training Matrix: All Workers',
    'training-matrix-deployed-by-project': 'Training Matrix: Deployed by Project',
    'training-matrix-deployed-flat': 'Training Matrix: Deployed Flat',
    'visa-expiry': 'Visa Expiry Report',
    'deployment-week': 'Weekly Deployment Grid (previous week)',
};
export const SCHEDULE_FREQUENCIES = ['daily', 'weekly', 'monthly', 'quarterly'];
export const SCHEDULE_FREQUENCY_LABELS = {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
};
export const SCHEDULE_FORMATS = ['pdf', 'excel'];
export const SCHEDULED_REPORT_DAY_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
export const scheduledReportSchema = z.object({
    name: z.string().optional(),
    reportType: z.enum(SCHEDULED_REPORT_TYPES),
    schedule: z.enum(SCHEDULE_FREQUENCIES),
    time: z.string().regex(/^\d{2}:\d{2}$/),
    weekday: z.number().int().min(0).max(6).nullable().optional(),
    dayOfMonth: z.number().int().min(1).max(28).nullable().optional(),
    format: z.enum(SCHEDULE_FORMATS).default('pdf'),
    recipients: z.array(z.string().email()).min(1),
    enabled: z.boolean().default(true),
    createdBy: z.string().nullable().optional(),
});
export function scheduleSummary(frequency, weekday, dayOfMonth, time) {
    const freq = SCHEDULE_FREQUENCY_LABELS[frequency] ?? frequency;
    let detail = '';
    if (frequency === 'weekly' && weekday != null) {
        detail = ` (${SCHEDULED_REPORT_DAY_NAMES[weekday] ?? ''})`;
    }
    else if ((frequency === 'monthly' || frequency === 'quarterly') && dayOfMonth != null) {
        detail = ` (Day ${dayOfMonth})`;
    }
    return `${freq}${detail} at ${time}`;
}
/**
 * Normalises and de-duplicates a list of email addresses, preserving the first
 * occurrence's casing. Comparison is case-insensitive and trims surrounding
 * whitespace; empty strings are dropped. Used both at save time (so the DB
 * stays clean) and at dispatch time (defensive against legacy rows).
 */
export function dedupeEmails(emails) {
    const seen = new Set();
    const out = [];
    for (const raw of emails) {
        const trimmed = (raw ?? '').trim();
        if (!trimmed)
            continue;
        const key = trimmed.toLowerCase();
        if (seen.has(key))
            continue;
        seen.add(key);
        out.push(trimmed);
    }
    return out;
}
export function autoScheduleName(reportType, frequency, weekday, dayOfMonth, time) {
    const reportLabel = SCHEDULED_REPORT_TYPE_LABELS[reportType] ?? reportType;
    return `${reportLabel} · ${scheduleSummary(frequency, weekday, dayOfMonth, time)}`;
}
//# sourceMappingURL=scheduled-report.js.map